<template>
    <div class="info" :style="{width:infoshow?'28vw':'4vw'}">
        <i class="el-icon-s-fold retract" @click="infoshow=!infoshow" v-if="infoshow"></i>
        <i class="el-icon-s-unfold retract" @click="infoshow=!infoshow" v-else></i>
        <i class="el-icon-back backprevious" @click="exitFullscreen"></i>
            <el-form v-if="infoshow">
                <el-form-item label="难度:" label-width="10vw">{{diffType==1?'简单':diffType==2?'正常':diffType==3?'困难':'自定义'}}</el-form-item>
                <el-form-item label="错误:" label-width="10vw">{{errorNum}}个</el-form-item>
                <el-form-item label="上次得分:" label-width="10vw">
                    {{trecordlist.length<=0?'-':trecordlist[0].rightRate}}分
                    <div v-if="trecordlist.length>0">
                        <img src="@/assets/game/down.png" class="rank_icon" v-if="trecordlist[0].rightRate<trecordlist[1].rightRate">
                        <img src="@/assets/game/up.png" class="rank_icon" v-else>
                        <span style="color: #02C9C9;">{{trecordlist[0].rightRate>=trecordlist[1].rightRate?trecordlist[0].rightRate-trecordlist[1].rightRate:trecordlist[1].rightRate-trecordlist[0].rightRate}}分</span>
                    </div>
                </el-form-item>
                <el-form-item label-width="10vw">排名 <span style="color: #FFC300;">{{rankDetail.lastRank}}</span></el-form-item>
                <el-form-item label="本次得分:" label-width="10vw">{{score}}分</el-form-item>
                <el-form-item label-width="10vw">实时排名 <span style="color: #02C9C9;">-</span></el-form-item>
            </el-form>
    </div>
</template>
<script>
export default{
    props:['errorNum','score','rankDetail'],
    data() {
        return {
            infoshow:false,
            diffType:this.$route.query.diffType,
            trecordlist:[],
            trainrecordparams:{
                pageIndex:1,
                pageSize:10,
                count:''
            }
        }
    },
    created() {
        this.getrecordlist()
    },
    methods: {
        detailinfo(){
         this.infoshow=false;   
        },
        getrecordlist(){
            this.$Http_Post('app/game/getrecordlist',this.trainrecordparams).then(res=>{
                if(res.Code==0){
                    this.trecordlist=res.Data;
                }else{
                    this.$message({type: 'error', message: res.Message})
                }
            })
        },
        // 退出全屏
        exitFullscreen(){
            this.$parent.exitFullscreen();
        }
    },
}
</script>
<style scoped>
.info{display: flex;align-items: center;height: 100%;border-right: 1px solid rgb(2 201 201 / 10%);width:28vw;position: relative;}
.el-form-item{margin-bottom: 0;}
.el-form-item__label{line-height:1;}
.rank_icon{width: 1.5em;top:.3em;position: relative;}
.retract{position: absolute;top: .5em;right:.5em;z-index:2;font-size: 1.5em;color: #02C9C9;}
.backprevious{position: absolute;right: -1em;top: 0.5em;font-size: 1.5em;z-index:5;}
</style>